import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NeoCardModule } from '@neogov/pattern-library/neo-card';

@Component({
  selector: 'cm-card',
  standalone: true,
  imports: [CommonModule, NeoCardModule],
  templateUrl: './card.component.html',
  styleUrl: './card.component.less',
})
export class CardComponent {

}
